<template>
	<div>
		<main role="main" style="padding:0px">
			<div class="container-fluid right_wrapper">
				<CampaignListHeader :showAssociatedFilter='true' :showFilters="false" @getList = "getList" ></CampaignListHeader>
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px;"></div>
				<NoDataAvailable
					displayMessage="No Data Available"
					v-else-if="!showLoader && campaignList.length == 0"
				></NoDataAvailable>
				<!-- <div v-else-if="!showLoader && campaignList.length == 0" style = "text-align:center;font-size:30px;margin-top:20px"><p>No Data Available</p></div> -->
				<div v-else class="addToCamp">
					<CampaignListGrid class="table_wrap dec_height" :campaignList="filterOnAssociate(campaignList)" @getList = "getList"></CampaignListGrid>
					<CampaignListGridFooter v-if=" campaignList.length && (!selectedAssociateFilter || selectedAssociateFilter=='All')" @openCampaignModal="openCampaignModal" :modalShow="modalShow"  :getFilteredResult = "true" @getList = "getList" ></CampaignListGridFooter>
				</div>
			</div>
		</main>
		<AddCampaignGroupModal v-if="modalShow" v-model="modalShow"></AddCampaignGroupModal>
	</div>
</template>

<script>
import CampaignListHeader from "@/components/campaign-list/CampaignListHeader";
import CampaignListGrid from "@/components/campaign/CampaignListGridAdd";
import CampaignListGridFooter from "@/components/campaign/CampaignListGridFooter";
import AddCampaignGroupModal from "@/components/campaign-group/AddCampaignGroupModal";
import NoDataAvailable from "../NoDataAvailable.vue";
export default {
	name: "CampaignList",
	data() {
		return {
			modalShow: false
		};
	},
	components: {
		CampaignListHeader,
		CampaignListGrid,
		CampaignListGridFooter,
		AddCampaignGroupModal,
		NoDataAvailable
	},
	computed: {
		selectedAssociateFilter: {
			get(){
				return this.$store.state.campaign.selectedAssociateFilter;
			},
			set(val){
				this.$store.state.campaign.selectedAssociateFilter = val;
			}
		},
		campaignList: {
			set(val) {
				this.$store.state.campaign.campaignList = val;
			},
			get() {
				return this.$store.state.campaign.campaignList;
			}
		},
		showLoader: {
			get() {
				return this.$store.getters["getShowLoader"];
			}
		}
	},
	mounted() {


		this.getList()

	},
	methods: {
		initializeCampaignListStatus(campaignList,type) {
			let id  = [];
			let vm  = this;
			if(this.$route.params.products.includes('+')){
				id = this.$route.params.products.split('+')
			}
			else{
				id.push(this.$route.params.products)
			}
			for(let i=0; i<campaignList.length; i++) {
				let status = {}
				let asins = (campaignList[i].id ? campaignList[i].id.split(',') : [])
				let added = [];
				id.map((response) => {
				added = asins.filter((res) => {
					 return	response == res
					})
				})
				if(added.length){
				   status.uploaded = 'toRemove'
				}
				else{
					status.uploaded = 'toAdd'
				}
				campaignList[i].status = status.uploaded
			}
			campaignList = campaignList.filter(item=>item.status==type)
			return campaignList
		},
		initializeStatus(campaignList,type){
			let list = this.$route.params.products.split('+')
			for(let i = 0; i<campaignList.length; i++){
				if(campaignList[i].id){
					let idList = campaignList[i].id.split(',')
					let flag = 0;
					for(let j=0; j<list.length; j++){
						for(let k=0; k<idList.length; k++){
							if(list[j] == idList[k]){
								flag ++;
								break;
							}
						}
					}
					if(flag == list.length){
						campaignList[i].status = "toRemove"
					}
					else if(flag == 0){
						campaignList[i].status = "toAdd"
					}
					else{
						campaignList[i].status = "addRemove"
					}
				}
				else{
					this.campaignList[i].status = "toAdd"
				}
			}
			campaignList =  campaignList.filter(item=>item.status==type)
			return campaignList
		},
		filterOnAssociate(list){
			if(this.selectedAssociateFilter == 'Associated'){
				let filteredList = []
				if(this.$route.params.products.includes('+')){
					filteredList = this.initializeStatus(list,'toRemove')
				}
				else{
					filteredList = this.initializeCampaignListStatus(list,'toRemove')
				}
				filteredList.forEach(item => {if(item){delete item.status}})
				return filteredList
			}
			else if(this.selectedAssociateFilter == 'Non-associated'){
				let filteredList = []
				if(this.$route.params.products.includes('+')){
					filteredList = this.initializeStatus(list,'toAdd')
				}
				else{
					filteredList = this.initializeCampaignListStatus(list,'toAdd')
				}
				filteredList.forEach(item=> {if(item){delete item.status}})
				return filteredList
			}
			else{
				return list
			}
		},
		saveNewCampaignGroup(Item) {
			let vm = this;
			this.$store
				.dispatch("campaign/addCampaignToCampaignGroups", Item)
				.then(res => {
					vm.$store.dispatch("campaign/getCampaignGroupList").then(res => {
						console.log("Called");
					});
				});
		},
		openCampaignModal() {
			$(".go-popover").popover("hide");
			this.modalShow = !this.modalShow;
			// this.$refs.campaignModal.modal.show()
		},
		getList(){
			let payload = {};
			if(this.$route.params.vendorId){
				payload.vendorId = this.$route.params.vendorId
				payload.profile_id = this.$route.params.brandId

			}

			this.$store.dispatch("campaign/getCampaignList", payload);
		}
	}
};
</script>

<style lang="scss">
.addToCamp{
	.dec_height{
		height: calc(100vh - 215px) !important;
	}
}
</style>
